import styled from 'styled-components';
import LegacyImage from 'next/legacy/image';
import { Fontw35s72h80, Fontw4s16h24 } from 'styles/commonCss';
import cloudinaryLoader from 'lib/image/cloudinary-loader';
import useClientSideMediaQuery from 'hooks/use-client-side-media-query';
import { mqSmallMax, mqSXLargeMin } from 'styled/tools/media-queries';

const Container = styled.div`
  background-color: var(--fill-primary);
  padding: 72px 48px 72px 48px;

  @media ${mqSmallMax} {
    padding: 48px 24px 48px 24px;
  }
`;

const Section = styled.section`
  gap: 96px;
  display: flex;

  @media ${mqSmallMax} {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 46%;
  margin-left: 0px;

  @media (max-width: 991px) {
    width: 100%;
  }
`;

const Title = styled.h1`
  ${Fontw35s72h80}
  color: var(--text-primary);
  letter-spacing: -1.44px;

  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 49px;
  }
`;

const Description = styled.p`
  ${Fontw4s16h24}
  color: var(--text-primary);
  margin-top: 48px;
`;

const ImageContainer = styled.div`
  line-height: normal;
  width: 44%;
  margin-top: 35px;

  @media ${mqSmallMax} {
    width: 100%;
    margin-top: 48px;
  }
`;

const MicrobialInnovation = () => {
  const isSmall = !useClientSideMediaQuery(mqSXLargeMin);

  return (
    <Container>
      <Section>
        <TextContainer>
          <Title>Who is Seed?</Title>
          {isSmall && (
            <ImageContainer>
              <LegacyImage
                src='https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1702517918/practitioners/innovations-armpits-bees-culture-earth.png'
                loader={cloudinaryLoader}
                width={1104}
                height={1104}
                alt='armpits, bees, culture, earth'
              />
            </ImageContainer>
          )}
          <Description>
            Seed Health is a microbiome science company pioneering clinically
            validated innovations for gut and whole body health. Rooted in
            rigorous research and peer-reviewed studies, the company is setting
            new standards for efficacy, safety, and trust in the biotics
            category. Seed’s pipeline of gut-directed innovations, developed in
            collaboration with world-renowned researchers and clinicians,
            harnesses the microbiome as a driver of longevity, systemic health,
            and daily wellbeing. Grounded in the ethos that human and planetary
            health are interconnected, SeedLabs, the company’s environmental
            research division, advances microbial interventions to enhance
            biodiversity and help restore ecosystems impacted by human activity.
          </Description>
        </TextContainer>
        {!isSmall && (
          <ImageContainer>
            <LegacyImage
              src='https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1702517918/practitioners/innovations-armpits-bees-culture-earth.png'
              loader={cloudinaryLoader}
              width={1104}
              height={1104}
              alt='armpits, bees, culture, earth'
            />
          </ImageContainer>
        )}
      </Section>
    </Container>
  );
};

export default MicrobialInnovation;
